import script from "./VideoUploaderBox.vue?vue&type=script&lang=ts&setup=true"
export * from "./VideoUploaderBox.vue?vue&type=script&lang=ts&setup=true"

import "./VideoUploaderBox.vue?vue&type=style&index=0&id=5cd58581&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5cd58581"]])

export default __exports__